import React from 'react';
import Swiper from 'react-id-swiper';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import HmEventRegistry from '../../../model/HmEventRegistry';

// ES6 classNameNameName-style
class Culture extends PreLoginSessionCheck {
  componentDidMount(){
	  HmEventRegistry.fireEvent("INITIATE_GA");
  }
  render() {

  	return(
		<section className="product-main h4 dna-chart">
			<div className="container">
				<h2> Our DNA and Culture</h2>
				<div className="main-circle">
					<div className="text-center">
						<img src="../img/chart-circle-1.png" alt=""/>
					</div> 
					<div data-hover-ga="Who we are - Our DNA and Culture - Intensely collaborative - flip" className="flip-container"  id="card01">
						<div className="flip-cards">
							<div className="front-card">
								<img src="../img/d1.png" alt=""/>
							</div>
							<div className="reverse-card" id="card1">
								<p>Magic happens when different disciplines come together</p>
							</div>
						</div> 
						<div className="clear"></div>
						<p>Intensely collaborative</p>
					</div>

				<div data-hover-ga="Who we are - Our DNA and Culture - Colorfully diverse - flip" className="flip-container"  id="card02">
						<div className="flip-cards">
							<div className="front-card">
							 <img src="../img/d2.png" alt=""/>
							</div>
							<div className="reverse-card" id="card2">
							<p>Because different viewpoints lead to the best ideas</p>
							</div>
						</div>
						<div className="clear"></div>
						<p>Colorfully diverse</p>
						<div className="line"></div>
					</div>

					<div data-hover-ga="Who we are - Our DNA and Culture - Atmosphere of a campus - flip" className="flip-container" id="card03">
						<div className="flip-cards">
							<div className="front-card" >
							 <img src="../img/d3.png" alt=""/>
							</div>
							<div className="reverse-card" id="card3">
							<p>17 years on we still feel like a startup</p>
							</div>
						</div>
						<div className="clear"></div>
						<p> Atmosphere of a campus</p>
					</div>

					<div data-hover-ga="Who we are - Our DNA and Culture - We've never stopped learning - flip" className="flip-container" id="card04">
						<div className="flip-cards">
							<div className="front-card" >
							 <img src="../img/d4.png" alt=""/>
							</div>
							<div className="reverse-card" id="card4">
							<p>Keeps us on top of the latest trends in education</p>
							</div>
						</div>
						<div className="clear"></div>
						<p className="cng-width"> We've never stopped learning </p>
					</div>

					<div data-hover-ga="Who we are - Our DNA and Culture - Value our Globality - flip" className="flip-container" id="card05">
						<div className="flip-cards">
							<div className="front-card">
							 <img src="../img/d5.png" alt=""/>
							</div>
							<div className="reverse-card" id="card5">
							<p>Sharing of best practices and richer ideation</p>
							</div>
						</div>
						<div className="clear"></div>
						<p> Value our Globality</p>
					</div>

				</div>
				<div className="what-we-do">
					<img src="../img/what-we-do.png" alt="" />
				</div>
			</div>
		</section>
  		);
  	}
}

export default Culture; 


// WEBPACK FOOTER //
// ./src/prelogin/src/components/Culture.js